import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Card, Col, Row, Spin } from "antd"
import useServices from "../../utils/useServices"

const { Meta } = Card

const StyledSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  padding: 6rem;

  .ant-spin-spinning {
    margin: 8rem;
    overflow: hidden;
    padding: 2rem;
  }
  .ant-card-body {
    background-color: #5a8d52;
  }
  .ant-card-meta-title {
    font-size: 20px;
    letter-spacing: 0px;
    line-height: 34px;
    color: #ffffff;
    font-weight: 700;
    text-align: center;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.xl)} {
    padding: 4rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    padding: 2rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    padding: 1rem;
  }
`

const ServicesSection = () => {
  const { services, loading } = useServices()

  return (
    <StyledSection>
      {loading ? (
        <Row justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <Row gutter={[16, 24]}>
          {services.map(service => (
            <Col sm={24} md={8} key={service.id}>
              <Card
                hoverable
                cover={
                  <img
                    alt="service-image"
                    src={service.featured_image.size_full}
                  />
                }
              >
                <Meta title={service.title.rendered} />
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </StyledSection>
  )
}

export default ServicesSection
